import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Work Orders ")
const _hoisted_5 = { class: "flex search" }
const _hoisted_6 = { class: "p-input-icon-left field-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_8 = { class: "container flex-grow-1 workorders" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Loading workorders "),
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner" })
], -1)
const _hoisted_10 = {
  key: 1,
  class: "container flex-grow-1"
}

import { useAuth0 } from "@auth0/auth0-vue";
import { ref } from "@vue/reactivity";
import { onMounted, onBeforeMount, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from "../store";
import { MutationTypes } from "../store/mutations";
import { FilterMatchMode } from 'primevue/api';
import { useToast } from 'primevue/usetoast';
import ErrorModal from './ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';


export default /*#__PURE__*/_defineComponent({
  name: 'DVIWorkOrders',
  setup(__props) {

const posthog = inject("posthog");
const auth0 = useAuth0();
const filters = ref({
  'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
});
const storeid = ref('');
const role = ref('');
const storestatus = ref('');
const loading = ref(false);
const empty = ref(false);
const router = useRouter();
const route = useRoute();
const completed = route.params.completed;
const store = useStore();
const reloadInterval = ref();
const itemlist = ref();

/**
 * On before mount sets the initial data
 */
onBeforeMount(async () => {
    storeid.value = store.state.storeid;
    role.value = store.state.role;
    storestatus.value = store.state.storestatus;
    if (storestatus.value == 'Disable') {
        router.push('/storedisable');
    }

    /**
     * On initial load, there will be no interval if reload detail status is false
     */
    const reloadDetails = await getReloadDetails();
    handleReloadDetails(reloadDetails);
});

/**
 * Call load work order function in order to populate WO items
 */
onMounted(async () => {
    if (completed) {
        toast.add({ severity: 'success', summary: 'Successful', detail: 'Work Order Completed', life: 3000 });
    }

    await getInspectionNotes();
    await loadWorkOrders();
});

/**
 * Load work orders and assign data by VUE mutation
 */
const loadWorkOrders = async () => {
    loading.value = true;
    const storeid = store.state.storeid;
    const WOurl = process.env.VUE_APP_NODEJS_BASE_URL + "dviworkorders/" + storeid;

    try {
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(WOurl, {
            headers: {
            Authorization: `Bearer ${accessToken}`,
            },
        });
        loading.value = false;
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
        let actualData = data.message;
        if (actualData === undefined) {
            actualData = [];
        }

        /**
         * Saving data to dviwoitems in VUEX is needed every time new changes were made in the list
         */
        store.commit(MutationTypes.SET_DVIWOITEMS, actualData);

        if ((actualData.length) < 1) {
            empty.value = true;
        } else {
            itemlist.value = actualData.map((b) => {
            return {
                FullName: `${b.FirstName} ${b.LastName}`,
                InUsage: new Intl.NumberFormat().format(b.InUsage),
                WorkOrderID: b.WorkOrderID,
                WorkOrderNumber: b.WorkOrderNumber,
                Plate: b.Plate,
                Make: b.Make,
                Model: b.Model,
                Color: b.Color,
                Technician: b.Technician
            };
            });
            empty.value = false;
        }
    } catch (e) {
        openErrorModal(e.message);
    }
}

/**
 * Get inspection notes and assign data by VUE mutation
 */
const getInspectionNotes = async () => {
    const storeid = store.state.storeid;
    const WOurl = process.env.VUE_APP_NODEJS_BASE_URL + "dviworkorders/inspectionnotes/" + storeid;

    try {
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(WOurl, {
            headers: {
            Authorization: `Bearer ${accessToken}`,
            },
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }

        var inspectionCollection = [];
        if ((data.message != null) && (data.message.ItemCollection.length != 0)){
            inspectionCollection = data.message.ItemCollection;
        }
        store.commit(MutationTypes.SET_INSPECTION_NOTES, inspectionCollection);
        
    } catch (e) {
        openErrorModal(e.message);
    }
}

/**
 * Actual API request to API server
 */
const getReloadDetails = async () => {
    const accessToken = await auth0.getAccessTokenSilently();
    const WOurl = `${process.env.VUE_APP_NODEJS_BASE_URL}application/config/1`;

    try {
        const response = await fetch(WOurl, {
            headers: {
            Authorization: `Bearer ${accessToken}`,
            },
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
        return data;
    } catch (e) {
        openErrorModal(e.message);
    }
}

/**
 * if reload detail status is true, set interval of load workorder based on the period of reload detail
 * Clear interval if the reload detail status is false
 * @param reloadDetails 
 */
const handleReloadDetails = (reloadDetails) => {
    if (reloadDetails.message && reloadDetails.message.configstatus === 1) {
        if (reloadInterval.value === undefined) {
            const minute = 60000; // 1 minute in milliseconds
            reloadInterval.value = setInterval(assessReloadDetails, reloadDetails.message.parameter1 * minute);
        }
    } else if (reloadDetails.message && reloadDetails.message.configstatus !== 1) {
        clearInterval(reloadInterval.value);
    }
};

/**
 * Get reload details to see if the status has been updated
 * then load the work orders
 */
const assessReloadDetails = async () => {
    const reloadDetails = await getReloadDetails();
    handleReloadDetails(reloadDetails);
    await loadWorkOrders();
}

/**
 * Clear filter by calling initialize function
 */
const clearFilter = () => {
    initFilters();
}

/**
 * Initialize filter
 */
const initFilters = () => {
    filters.value = {
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
}

const toast = useToast();

/**
 * Push to vue router when a work order package is selected
 * @param event 
 */
 const onRowSelect = (event) => {
    const { email }  = { ...auth0.user.value };
    const storeid = auth0.user.value['http://protractor.com/storeid'];
    posthog.capture("dviwostart_button_clicked", { email: email, storeid: storeid });
    store.commit(MutationTypes.SET_CURRENTWORKORDERNUMBER, event.data.WorkOrderNumber);
    store.commit(MutationTypes.SET_CURRENTWORKORDERID, event.data.WorkOrderID);
    router.push({ name: 'dviworkorderpackages', params: { workordernumber: event.data.WorkOrderNumber,workorderid: event.data.WorkOrderID } });
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-refresh",
            class: "p-button-text p-button-rounded",
            onClick: loadWorkOrders
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_InputText, {
            modelValue: filters.value['global'].value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value['global'].value) = $event)),
            placeholder: "Search"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            class: "p-button-text p-button-rounded clear",
            onClick: clearFilter
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (!empty.value)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            value: itemlist.value,
            paginator: true,
            rows: 10,
            stripedRows: "",
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
            rowsPerPageOptions: [10, 20, 50],
            breakpoint: "640px",
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
            filters: filters.value,
            selectionMode: "single",
            onRowSelect: onRowSelect,
            loading: loading.value,
            dataKey: "WorkOrderNumber"
          }, {
            loading: _withCtx(() => [
              _hoisted_9
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "WorkOrderNumber",
                header: "WO #",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "FullName",
                header: "Full Name",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "Plate",
                header: "Plate #",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "Make",
                header: "Make",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "Model",
                header: "Model",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "Color",
                header: "Color",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "InUsage",
                header: "Odo.",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "Technician",
                header: "Tech.",
                sortable: true
              })
            ]),
            _: 1
          }, 8, ["value", "filters", "loading"]))
        : _createCommentVNode("", true),
      (empty.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "No work orders found."))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})